<template>
<div>
  <bordered-container title='Samenvatting' class='mb-2'>
    <table class='confirmation-table confirmation-table-adjust-padding mt-2 mb-2'>
      <tr>
        <td>{{ 'work-stock.fields.employer' | translate }}</td>
        <td>{{ employerName }}</td>
      </tr>
      <tr>
        <td>{{ 'work-stock.fields.employee' | translate }}</td>
        <td>{{ workStockItem.employeeCustomerNumber }}</td>
      </tr>
      <tr>
        <td>{{ 'work-stock.fields.action' | translate }}</td>
        <td>
          {{ 'work-stock.fields.actions.' + workStockItem.action | translate }}
          {{ 'work-stock.fields.work-stock-types.' + workStockItem.workStockType | translate }}
        </td>
      </tr>
      <tr>
        <td>{{ 'work-stock.fields.reason' | translate }}</td>
        <td style='width: 60%'>{{ workStockItem.reason }}</td>
      </tr>
      <tr v-if="workStockItem.treatedBy">
        <td>{{ 'work-stock.fields.treatedBy' | translate }}</td>
        <td>{{ workStockItem.treatedBy }}</td>
      </tr>
      <tr>
        <td>{{ 'work-stock.fields.status' | translate }}</td>
        <td><work-stock-status :status="workStockItem.status" style='left: 8px;' /></td>
      </tr>
      <tr>
        <td>{{ 'work-stock.fields.createdOn' | translate }}</td>
        <td>{{ formatDate(workStockItem.createdOn) }}</td>
      </tr>
    </table>
  </bordered-container>
  <action-link v-if="workStockItem != null && ['UwvDecision', 'ReportOfSickness'].indexOf(workStockItem.workStockType) > -1"
    right @click="handleNavigateReportOfSickness">
    Ga naar verzuimmelding
  </action-link>

</div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';
import ReportsOfSickness from '@/views/constants/reports-of-sickness';
import AppNavigation from '@/views/constants/app-navigation';

import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';
import ActionLink from '@aevitae/aevitaeui/0_atoms/buttons/ActionLink.vue';

import WorkStockStatus from '@/views/components/work-stock/WorkStockStatus.vue';

export default {
  name: 'WorkStockItemSummary',
  components: {
    BorderedContainer,
    WorkStockStatus,
    ActionLink
  },
  props: {
    workStockItem: Object
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),

    handleNavigateReportOfSickness () {
      if (this.employee && this.reportOfSickness) {
        this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.ReportsOfSickness)
          .then(this.$store.dispatch(ReportsOfSickness.Actions.Tabs.OPEN_DETAILS, {
            reportOfSickness: this.reportOfSickness,
            employee: this.employee
          }));
      } else {
        this.$store.dispatch(Modal.Actions.OPEN, {
          component: 'Warning',
          title: 'Selecteer Werkgever',
          text: 'Selecteer de corresponderende werkgever (rechtsboven) om middels deze knop naar de Verzuim Details pagina te gaan.'
        });
      }
    }
  },

  computed: {
    employerName () {
      const employer = this.$store.getters.employers.find(e => e.customerNumber === this.workStockItem.employerCustomerNumber);
      if (employer != null) return `${employer.tradeName} (${employer.customerNumber})`;
      else return this.workStockItem.employerCustomerNumber;
    },

    employee () {
      return this.$store.getters.employees
        .find(e => e.id === this.workStockItem.employeeCustomerNumber);
    },

    reportOfSickness () {
      return this.$store.getters.reportsOfSicknessFlat
        .find(r => r.id === this.workStockItem.reportOfSicknessId);
    }
  }
};
</script>

<style lang='scss' scoped>
.confirmation-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}
</style>
